export default __webpack_public_path__ + "static/media/Image28.43771956.png";